import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminLogin from "./pages/AdminLogin";
import PartnerLogin from "./pages/PartnerLogin";
import DriverLogin from "./pages/DriverLogin";
import PartnerDashboard from "./pages/PartnerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import DriverDashboard from "./pages/DriverDashboard";
import FloatingSocialMenu from "./components/SocialMediaButton/FloatingSocialMenu.jsx";

const App = () => {
  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/partner/login" element={<PartnerLogin />} />
            <Route path="/driver/login" element={<DriverLogin />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/driver/dashboard" element={<DriverDashboard />} />
            {/* if path is anything different, redirect to root*/}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>
      </Router>
      <FloatingSocialMenu />
    </>
  );
};

export default App;
